<div class="row">
    <div class="col-sm-12 text-center">
        Mobile Mode
    </div>
</div>